import { render, staticRenderFns } from "./create-task-modal.vue?vue&type=template&id=89767862&scoped=true&"
import script from "./create-task-modal.vue?vue&type=script&lang=ts&"
export * from "./create-task-modal.vue?vue&type=script&lang=ts&"
import style0 from "./create-task-modal.vue?vue&type=style&index=0&id=89767862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89767862",
  null
  
)

export default component.exports